import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, IconButton, Stack, TextField, Typography } from "@mui/material";
import classNames from "classnames/bind";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { acceptInvitation, isFull, rejectInvitation, removeInvitation } from "../../services/TeamService";
import styles from "./index.module.css";


const TeamPopUp = ({ name, field, ideation, pos, toggle, refresh, teamInfo, eventId }) => {
  const cx = classNames.bind(styles);
  const history = useHistory();
  const [full, setFull] = useState(false);
  useEffect(() => {
    isFull(teamInfo.teamId)
      .then((value) => {
        console.log(value);
        setFull(value);
      })
      .catch(console.log);
  }, []);

  return (
    <Box className={cx("modal")}>
      <Box className={cx("pop-up-box")}>
        <Stack
          direction="row"
          justifyContent="space-between"
          width="100%"
        >
          <Typography
            padding="2% 0"
            fontSize="1.2em"
          >
            {name} 想邀請您成為團隊 {pos} ！👋
          </Typography>
          <IconButton onClick={toggle}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Box
          className={cx("field")}
          padding="1% 5%"
        >
          {field}
        </Box>
        <Typography
          marginTop="2%"
          color="#A6A6A6"
        >
          {ideation}
        </Typography>
        <Stack
          direction="row"
          justifyContent="flex-end"
          width="100%"
          marginTop="5%"
          marginRight="13%"
          spacing={2}
        >
          <Button size="large" className={cx("reject-btn")} onClick={() => {
            rejectInvitation(eventId, teamInfo.teamId, teamInfo.teamEventId);
            toggle();
            refresh();
          }}>
            <Typography
              fontSize="0.9em"
              color="#575757"
            >
              拒絕
            </Typography>
          </Button>
          <Button size="large" className={cx("accept-btn")} onClick={() => {
            if (full) {
              alert("隊伍人數已滿，無法加入。");
              removeInvitation(eventId, teamInfo.teamId, teamInfo.teamEventId);
              toggle();
              refresh();
            } else {
              acceptInvitation(teamInfo.teamId, pos, teamInfo.teamEventId);
              refresh();
              toggle();
              history.push("/team-1");
            }

          }}>
            <Typography fontSize="0.9em" color="#575757">
              接受
            </Typography>
          </Button>

        </Stack>
      </Box>
    </Box >
  );
};

export default TeamPopUp;
